<div *ngIf="items && items.length" [innerHtml]="items[0].content | sanitizeHtml: 'HTML' "> </div>